// src/lib/tvCommercialsData.js
// videoUrl: Cloudinary URL or self-hosted path, e.g. "/videos/tv/RTL_Martina_Ertl.mp4"
// Local videos: place file in public/videos/tv/ — see public/videos/README.md
// title: { de, en, fr, es } — add keys when introducing a new UI language.
const tvCommercialsData = [
  {
    id: "tv-spot-1",
    title: {
      de: "RTL Games Spot für RTL mit Martina Ertl",
      en: "RTL Games spot for RTL with Martina Ertl",
      fr: "Spot RTL Games pour RTL avec Martina Ertl",
      es: "Spot RTL Games para RTL con Martina Ertl",
    },
    date: "2005",
    videoUrl: "https://res.cloudinary.com/dbpoconup/video/upload/v1743612295/RTL_Martina_Ertl_hqkb9j.mp4",
    thumbnailUrl: "https://res.cloudinary.com/dbpoconup/image/upload/v1743612768/ski_apine_2005_game_gkr0zf.jpg",
  },
  {
    id: "tv-spot-2",
    title: {
      de: "Eunova TV Spot für GlaxoSmithKline mit Andrea Henkel - Winterversion",
      en: "Eunova TV spot for GlaxoSmithKline with Andrea Henkel – winter version",
      fr: "Spot TV Eunova pour GlaxoSmithKline avec Andrea Henkel – version hiver",
      es: "Spot TV Eunova para GlaxoSmithKline con Andrea Henkel – versión invierno",
    },
    date: "2003 - Winterversion 1",
    videoUrl: "https://res.cloudinary.com/dbpoconup/video/upload/v1743612296/Andrea_Henkel_Winter_15sek_cogrdk.mp4",
    thumbnailUrl: "https://res.cloudinary.com/dbpoconup/image/upload/v1743612296/Andrea_Henkel_Winter_15sek_cogrdk.mp4",
  },
  {
    id: "tv-spot-3",
    title: {
      de: "Floradix Kräuterblut TV Spot für salus Naturarzneimittel mit Martina Glagow",
      en: "Floradix Kräuterblut TV spot for salus with Martina Glagow",
      fr: "Spot TV Floradix Kräuterblut pour salus avec Martina Glagow",
      es: "Spot TV Floradix Kräuterblut para salus con Martina Glagow",
    },
    date: "2006",
    videoUrl: "https://res.cloudinary.com/dbpoconup/video/upload/v1743612295/Martina_Glagow_likztq.mp4",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-4",
    title: {
      de: "Nutella TV Spot für Ferrero mit Martina Ertl - Sommerversion",
      en: "Nutella TV spot for Ferrero with Martina Ertl – summer version",
      fr: "Spot TV Nutella pour Ferrero avec Martina Ertl – version été",
      es: "Spot TV Nutella para Ferrero con Martina Ertl – versión verano",
    },
    date: "2001-2003 - Sommersaison",
    videoUrl: "https://res.cloudinary.com/dbpoconup/video/upload/v1743612295/Martina_Ertl_Sommerversion_hcx6ha.mp4",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-5",
    title: {
      de: "Nutella TV Spot für Ferrero mit Martina Ertl - Winterversion",
      en: "Nutella TV spot for Ferrero with Martina Ertl – winter version",
      fr: "Spot TV Nutella pour Ferrero avec Martina Ertl – version hiver",
      es: "Spot TV Nutella para Ferrero con Martina Ertl – versión invierno",
    },
    date: "2001-2003 - Wintersaison",
    videoUrl: "https://res.cloudinary.com/dbpoconup/video/upload/v1743612295/Martina_Ertl_Winterversion_birrsq.mp4",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-6",
    title: {
      de: "Eunova TV Spot für GlaxoSmithKline mit Andrea Henkel - Winterversion",
      en: "Eunova TV spot for GlaxoSmithKline with Andrea Henkel – winter version",
      fr: "Spot TV Eunova pour GlaxoSmithKline avec Andrea Henkel – version hiver",
      es: "Spot TV Eunova para GlaxoSmithKline con Andrea Henkel – versión invierno",
    },
    date: "2003 - Winterversion 2",
    videoUrl: "https://res.cloudinary.com/dbpoconup/video/upload/v1743612295/Andrea_Henkel_Final_OFFLINE_lragsv.mp4",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-7",
    title: {
      de: "Pattex TV Spot für Henkel AG & Cop. KGaA mit Marko Marin",
      en: "Pattex TV spot for Henkel with Marko Marin",
      fr: "Spot TV Pattex pour Henkel avec Marko Marin",
      es: "Spot TV Pattex para Henkel con Marko Marin",
    },
    date: "2007",
    videoUrl: "https://res.cloudinary.com/dbpoconup/video/upload/v1743612295/marin_mpeg2video_tgwjpo.mp4",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-8",
    title: {
      de: "TV-Spot für Telegate mit Magdalena Neuner",
      en: "TV spot for Telegate with Magdalena Neuner",
      fr: "Spot TV pour Telegate avec Magdalena Neuner",
      es: "Spot TV para Telegate con Magdalena Neuner",
    },
    date: "2008",
    videoUrl:
      "https://res.cloudinary.com/dbpoconup/video/upload/v1774092309/11880_TV-Spot_f%C3%BCr_Telegate_mit_Magdalena_Neuner_iauxtm.mpeg",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-9",
    title: {
      de: "Gelo Myrtol forte – TV-Spot für Pohl Boskamp mit Martina Ertl",
      en: "Gelo Myrtol forte – TV spot for Pohl Boskamp with Martina Ertl",
      fr: "Gelo Myrtol forte – spot TV pour Pohl Boskamp avec Martina Ertl",
      es: "Gelo Myrtol forte – spot TV para Pohl Boskamp con Martina Ertl",
    },
    date: "2003-2005",
    videoUrl:
      "https://res.cloudinary.com/dbpoconup/video/upload/v1774092310/Gelo_Myrtol_forte_-_TV_Spot_f%C3%BCr_Pohl_Boskamp_mit_Martina_Ertl_xp4r67.mpeg",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-10",
    title: {
      de: "Imagefilm Julia Görges",
      en: "Corporate film Julia Görges",
      fr: "Film institutionnel Julia Görges",
      es: "Película corporativa Julia Görges",
    },
    date: "2015",
    videoUrl: "https://res.cloudinary.com/dbpoconup/video/upload/v1774092312/Imagefilm_Julia_Goerges_ykg0vr.wmv",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-11",
    title: {
      de: "Eric Frenzel-Uhr – Behind the Scenes 01",
      en: "Eric Frenzel watch – Behind the scenes 01",
      fr: "Montre Eric Frenzel – Coulisses 01",
      es: "Reloj Eric Frenzel – Tras las cámaras 01",
    },
    date: "2020",
    videoUrl: "https://res.cloudinary.com/dbpoconup/video/upload/v1774092865/Eric_Frenzel-Uhr_Behind_the_scenes_01_fnwszo.mp4",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-12",
    title: {
      de: "Eric Frenzel-Uhr – TV-Spot für C. H. Wolf mit Eric Frenzel",
      en: "Eric Frenzel watch – TV spot for C. H. Wolf with Eric Frenzel",
      fr: "Montre Eric Frenzel – spot TV pour C. H. Wolf avec Eric Frenzel",
      es: "Reloj Eric Frenzel – spot TV para C. H. Wolf con Eric Frenzel",
    },
    date: "2020",
    videoUrl:
      "https://res.cloudinary.com/dbpoconup/video/upload/v1774092928/Eric_Frenzel-Uhr_TV_Spot_f%C3%BCr_C.H.Wolf_mit_Eric_Frenzel_vel3mz.mp4",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-13",
    title: {
      de: "Eric Frenzel-Uhr – Behind the Scenes 02",
      en: "Eric Frenzel watch – Behind the scenes 02",
      fr: "Montre Eric Frenzel – Coulisses 02",
      es: "Reloj Eric Frenzel – Tras las cámaras 02",
    },
    date: "2020",
    videoUrl: "https://res.cloudinary.com/dbpoconup/video/upload/v1774092870/Eric_Frenzel-Uhr_Behind_the_scenes_02_o7l4mp.mp4",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-14",
    title: {
      de: "VKF-Spot 02 für rupp+hubrach mit Eric Frenzel",
      en: "VKF spot 02 for rupp+hubrach with Eric Frenzel",
      fr: "Spot VKF 02 pour rupp+hubrach avec Eric Frenzel",
      es: "Spot VKF 02 para rupp+hubrach con Eric Frenzel",
    },
    date: "2026",
    videoUrl:
      "https://res.cloudinary.com/dbpoconup/video/upload/v1774095244/VKF-Spot_02_f%C3%BCr_Rupp_Hubrach_mit_Eric_Frenzel_kyt32b.mp4",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-15",
    title: {
      de: "Airbnb TV-Spot mit Karl Geiger",
      en: "Airbnb TV spot with Karl Geiger",
      fr: "Spot TV Airbnb avec Karl Geiger",
      es: "Spot TV Airbnb con Karl Geiger",
    },
    date: "2026",
    videoUrl:
      "https://res.cloudinary.com/dbpoconup/video/upload/v1780415337/AIRBNB_KARL_GIEGER_FINAL_2_nrsoci.mp4",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-16",
    title: {
      de: "rupp+hubrach Testimonialwerbung mit Eric Frenzel",
      en: "rupp+hubrach testimonial advertising with Eric Frenzel",
      fr: "Publicité témoignage rupp+hubrach avec Eric Frenzel",
      es: "Publicidad testimonial rupp+hubrach con Eric Frenzel",
    },
    date: "2026",
    videoUrl:
      "https://res.cloudinary.com/dbpoconup/video/upload/v1780415589/rh_frenzel_testimonial_007.prproj_zfmxxc.mp4",
    thumbnailUrl: "",
  },
  {
    id: "tv-spot-17",
    title: {
      de: "OTV-Bericht – Eric-Frenzel-Trails mit Eric Frenzel",
      en: "OTV report – Eric Frenzel Trails with Eric Frenzel",
      fr: "Reportage OTV – Eric-Frenzel-Trails avec Eric Frenzel",
      es: "Reportaje OTV – Eric-Frenzel-Trails con Eric Frenzel",
    },
    date: "2025",
    videoUrl:
      "https://res.cloudinary.com/dbpoconup/video/upload/v1780500863/OTV_Bericht_Eric_Frenzel_Trails_idezdl.mp4",
    thumbnailUrl: "",
  },
];

export default tvCommercialsData;
